import React from 'react';
import { Gift, BarChart3, ShieldAlert, Puzzle } from 'lucide-react';
const bonuses = [{
  icon: BarChart3,
  emoji: '📊',
  title: 'Seguimiento de Progreso del Niño',
  desc: 'Plantilla para medir avances con indicadores claros, espacio para notas y evolución semanal.',
  highlight: '👉 Refuerza la sensación de avance real.'
}, {
  icon: ShieldAlert,
  emoji: '🚫',
  title: 'Errores Comunes que Frenan el Desarrollo',
  desc: 'Guía rápida de lo que NO hacer: hábitos perjudiciales, malas prácticas y correcciones simples.'
}, {
  icon: Puzzle,
  emoji: '🧩',
  title: 'Kit de Actividades Imprimibles',
  desc: 'Material listo para usar: juegos imprimibles, tarjetas de ejercicios y actividades guiadas.'
}];
export const BonusSection = () => {
  return <section className="py-12" data-id="element-19">
      <div className="bg-gradient-to-br from-[#1B3A5C] to-[#2a5a8c] rounded-3xl p-6 sm:p-8 text-white shadow-xl relative overflow-hidden" data-id="element-20">
        <div className="absolute -top-10 -right-10 opacity-10" data-id="element-21">
          <Gift className="w-48 h-48" data-id="element-22" />
        </div>

        <div className="relative z-10" data-id="element-23">
          <div className="inline-block bg-[#F47B20] text-white font-black px-4 py-1 rounded-full text-sm mb-4 tracking-wider" data-id="element-24">
            OFERTA ESPECIAL
          </div>
          <h2 className="text-2xl sm:text-3xl font-black mb-1" data-id="element-25">
            Bonos Exclusivos
          </h2>
          <p className="text-lg text-blue-200 mb-6 font-medium" data-id="element-26">
            GRATIS POR EL DÍA DE HOY
          </p>

          <div className="space-y-3" data-id="element-27">
            {bonuses.map((b, i) => <div key={i} className="bg-white/10 backdrop-blur-sm px-4 py-3 rounded-xl border border-white/20 flex items-center gap-3" data-id="element-28">
                <div className="bg-[#F47B20] p-2 rounded-lg flex-shrink-0" data-id="element-29">
                  <b.icon className="w-5 h-5 text-white" data-id="element-30" />
                </div>
                <div className="min-w-0" data-id="element-31">
                  <h4 className="font-bold text-base leading-tight" data-id="element-32">
                    {b.emoji} {b.title}
                  </h4>
                  <p className="text-blue-100 text-sm leading-snug mt-0.5" data-id="element-33">
                    {b.desc}
                  </p>
                  {b.highlight && <p className="text-[#F47B20] font-bold text-xs mt-1" data-id="element-34">
                      {b.highlight}
                    </p>}
                </div>
                <span className="bg-green-500 text-white text-xs font-black px-2 py-1 rounded-full flex-shrink-0" data-id="element-35">
                  GRATIS
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};